import Image from 'next/image'
import { useRef, useCallback } from 'react'
import Slider from 'components/Slider'
import SnapCarousel from 'components/SnapCarousel'

import { desktopAdverts, mobileAdverts } from './data'
import { AdvertLink, AdvertSliderWrapper, DocumentNo } from './styled'
import { useAdvertState } from 'context/AdvertContext'
import { useIsMobile } from 'hooks/useIsMobile'
import { useAppState } from 'context/AppContext'
import { useDeviceType } from 'hooks/useDeviceType'
import sendTrackerLog from 'utils/tracker'
import { getAnalyticsRequestId } from '../../utils/analyticsRequestId'

const Advert = () => {
  const isMobile = useIsMobile()
  const { isTablet } = useDeviceType()
  const adverts = isMobile ? mobileAdverts : desktopAdverts
  const { selectedCategoryIndex } = useAdvertState(adverts)
  const { market } = useAppState()
  const isWingie = market !== 'tr'
  const startIndex = selectedCategoryIndex === -1 ? 0 : selectedCategoryIndex

  const advertContainerRef = useRef<HTMLDivElement>(null)

  // Advert banner click tracking
  const handleAdvertClick = useCallback(
    (linkUrl: string, imageUrl: string, altText: string, order: number) => {
      const environment = isMobile || isTablet ? 'MOBILE_WEB' : 'DESKTOP_WEB'
      const requestId = getAnalyticsRequestId()

      sendTrackerLog({
        category: isWingie ? 'wingie-homepage' : 'enuygun-homepage',
        page: isWingie ? 'wingie-homepage' : 'enuygun-homepage',
        type: 'click',
        message: 'advert_banner_click',
        environment: environment,
        requestId,
        linkUrl: linkUrl,
        bannerImageUrl: imageUrl,
        bannerAltText: altText,
        bannerOrder: order,
        isMobile: !!(isMobile || isTablet),
        market: market,
      })
    },
    [isMobile, isTablet, market, isWingie]
  )

  if (!isWingie) return null

  const renderAdverts = () =>
    adverts.map((advert, i) => (
      <AdvertLink
        key={advert.image}
        href={`${advert.link}?ref=hp-banner`}
        target="_blank"
        rel="noreferrer"
        onClick={() => handleAdvertClick(`${advert.link}?ref=hp-banner`, advert.image, advert.alt || '', i + 1)}
      >
        <Image src={advert.image} width={advert.width} height={advert.height} loading={startIndex === i ? undefined : 'lazy'} alt={advert.alt} priority={startIndex === i} />
      </AdvertLink>
    ))

  return (
    <AdvertSliderWrapper ref={advertContainerRef}>
      {isMobile ? (
        <SnapCarousel
          options={{
            perPage: 1,
            gap: 16,
          }}
          dataTestId="advert-carousel"
          containerWidth={1120}
          isMobile={true}
        >
          {renderAdverts()}
        </SnapCarousel>
      ) : (
        <Slider
          options={{
            arrows: false,
            gap: 16,
            fixedWidth: '1120px',
            perPage: 1,
            start: startIndex,
            type: 'loop',
            interval: 5000,
            autoplay: true,
          }}
        >
          {renderAdverts()}
        </Slider>
      )}
      {isMobile && <DocumentNo>Enuygun Seyahat, Belge No: 7153</DocumentNo>}
    </AdvertSliderWrapper>
  )
}

export default Advert
